import $ from 'jquery';
import { LocalGarage } from './local';

export function syncGlobalGarageIcon() {
  const $header = $('.js-header-garage').find('.filter-dot');

  if (!LocalGarage.isEmpty()) {
    $header.removeClass('hidden');
  } else {
    $header.addClass('hidden');
  }
}

export function syncGarageIcons() {
  $('[data-garage-toggle-id]').each(function () {
    const $garageToggle = $(this);
    const itemId = $garageToggle.data('garageToggleId');

    $garageToggle.prop('checked', itemId && LocalGarage.has(itemId));
  });
}
